const acuraModels = [
    { name: 'Select Model', disabled: true },
    { name: 'ILX', disabled: false },
    { name: 'MDX', disabled: false },
    { name: 'RDX', disabled: false },
    { name: 'RLX', disabled: false },
    { name: 'TLX', disabled: false },
    { name: 'TSX', disabled: false },
    { name: 'ZDX', disabled: false },
    { name: 'Integra', disabled: false },
    { name: 'NSX', disabled: false },
    { name: 'RL', disabled: false },
    { name: 'TL', disabled: false },
    { name: 'CL', disabled: false },
    { name: 'CSX', disabled: false }
]
const AlfaRomeoModels = [
    { name: 'Select Model', disabled: true },
    { name: '4C', disabled: false },
    { name: 'Giulia', disabled: false },
    { name: 'Stelvio', disabled: false },
    { name: 'Tonale', disabled: false },
    { name: 'Giulia Quadrifoglio', disabled: false },
    { name: 'Stelvio Quadrifoglio', disabled: false },
    { name: 'Giulia Veloce', disabled: false },
    { name: 'Stelvio Veloce', disabled: false },
    { name: 'Giulia Ti', disabled: false },
    { name: 'Stelvio Ti', disabled: false },
    { name: 'Giulia Ti Sport', disabled: false },
    { name: 'Stelvio Ti Sport', disabled: false },
    { name: 'Giulia Ti Sport', disabled: false },
    { name: 'Stelvio Ti Sport', disabled: false },
    { name: 'Giulia Ti Sport', disabled: false },
    { name: 'Stelvio Ti Sport', disabled: false },
    { name: 'Giulia Ti Sport Carbon', disabled: false },
    { name: 'Stelvio Ti Sport Carbon', disabled: false }
]
const audiModels = [
    { name: 'Select Model', disabled: true },
    { name: 'A1', disabled: false },
    { name: 'A3', disabled: false },
    { name: 'A4', disabled: false },
    { name: 'A5', disabled: false },
    { name: 'A6', disabled: false },
    { name: 'A7', disabled: false },
    { name: 'A8', disabled: false },
    { name: 'Q3', disabled: false },
    { name: 'Q5', disabled: false },
    { name: 'Q7', disabled: false },
    { name: 'Q8', disabled: false },
    { name: 'R8', disabled: false },
    { name: 'S3', disabled: false },
    { name: 'S4', disabled: false },
    { name: 'S5', disabled: false },
    { name: 'S6', disabled: false },
    { name: 'S7', disabled: false },
    { name: 'S8', disabled: false },
    { name : 'SQ5', disabled: false },
    { name: 'SQ7', disabled: false },
    { name: 'SQ8', disabled: false },
    { name: 'TT', disabled: false },
    { name: 'TT RS', disabled: false },
    { name: 'TTS', disabled: false }
]
const bmwModels = [
    { name: 'Select Model', disabled: true },
    { name: '2 Series', disabled: false },
    { name: '3 Series', disabled: false },
    { name: '4 Series', disabled: false },
    { name: '5 Series', disabled: false },
    { name: '6 Series', disabled: false },
    { name: '7 Series', disabled: false },
    { name: '8 Series', disabled: false },
    { name: 'i3', disabled: false },
    { name: 'i4', disabled: false },
    { name: 'i7', disabled: false },
    { name: 'i8', disabled: false },
    { name: 'M2', disabled: false },
    { name: 'M3', disabled: false },
    { name: 'M4', disabled: false },
    { name: 'M5', disabled: false },
    { name: 'M6', disabled: false },
    { name: 'M8', disabled: false },
    { name: 'X1', disabled: false },
    { name: 'X2', disabled: false },
    { name: 'X3', disabled: false },
    { name: 'X4', disabled: false },
    { name: 'X5', disabled: false },
    { name: 'X6', disabled: false },
    { name: 'X7', disabled: false },
    { name: 'Z4', disabled: false }
]
    const buickModels = [
        { name: 'Select Model', disabled: true },
        { name: 'Cascada' },
        { name: 'Enclave' },
        { name: 'Encore' },
        { name: 'Encore GX' },
        { name: 'Envision' },
        { name: 'LaCrosse' },
        { name: 'Lucerne' },
        { name: 'Regal' },
        { name: 'Regal Sportback' },
        { name: 'Regal TourX' },
        { name: 'Verano' }
    ]
    const cadillacModels = [
        { name: 'Select Model', disabled: true },
        { name: 'ATS' },
        { name: 'ATS-V' },
        { name: 'CT4' },
        { name: 'CT5' },
        { name: 'CT6' },
        { name: 'CT6-V' },
        { name: 'CT4-V' },
        { name: 'CT5-V' },
        { name: 'CT6-V Sport' },
        { name: 'CT5-V Sport' },
        { name: 'CT5-V Blackwing' },
        { name: 'CT5-V Sport Blackwing' },
        { name: 'CT5-V Sport Touring' },
        { name: 'CTS' },
        { name: 'CTS-V' },
        { name: 'CTS-V Sport' },
        { name: 'CTS-V Sport Wagon' },
        { name: 'CTS-V Sport Wagon' },
        { name: 'CTS-V Sport Wagon' },
        { name: 'CTS Wagon' }, 
        { name: 'CTS-V Wagon' }
    ]
    const chevroletModels = [
        { name: 'Select Model', disabled: true },
        { name: 'Astro' },
        { name: 'Avalanche' },
        { name: 'Aveo' },
        { name: 'Blazer' },
        { name: 'Bolt' },
        { name: 'Camaro' },
        { name: 'Camaro ZL1' },
        { name: 'Camaro LT1' },
        { name: 'Corvette Stingray' },
        { name: 'Corvette Z06' },
        { name: 'Caprice' },
        { name: 'Captiva' },
        { name: 'Cavalier' },
        { name: 'Chevelle' },
        { name: 'Chevy Van' },
        { name: 'Colorado' },
        { name: 'Corvette' },
        { name: 'Cruze' },
        { name: 'Cruze Limited' },
        { name: 'Equinox' },
        { name: 'Express' },
        { name: 'Express 2500' },
        { name: 'Express 3500' },
        { name: 'Express 4500' },
        { name: 'Express XL' },
        { name: 'Express Cargo' },
        { name: 'Express Cargo Van' },
        { name: 'Impala' },
        { name: 'Impala SS' },
        { name: 'Malibu' },
        { name: 'Malibu Limited' },
        { name: 'Malibu Maxx' },
        { name: 'Malibu Maxx Hybrid' },
        { name: 'Metro' },
        { name: 'Monte Carlo' },
        { name: 'Monte Carlo SS' },
        { name: 'Nova' },
        { name: 'Orlando' },
        { name: 'S-10' },
        { name: 'Silverado' },
        { name: 'Silverado 1500' },
        { name: 'Silverado 2500' },
        { name: 'Silverado 3500' },
        { name: 'Silverado 4500' },
        { name: 'Silverado 1500 HD' },
        { name: 'Silverado 2500 HD' },
        { name: 'Silverado 3500 HD' },
        { name: 'Silverado 4500 HD' },
        { name: 'Silverado 1500 HD Crew Cab' },
        { name: 'Silverado 2500 HD Crew Cab' },
        { name: 'Silverado 3500 HD Crew Cab' },
        { name: 'Silverado 4500 HD Crew Cab' },
        { name: 'Traverse' },
        { name: 'Traverse Hybrid' },
        { name: 'Trax' },
        { name: 'Trax Premier' },
        { name: 'Suburban' },
        { name: 'Tahoe' },
        { name: 'Volt' }
    ];
    const chryslerModels = [
        { name: 'Select Model', disabled: true },
        { name: '300' },
        { name: '300C' },
        { name: '300C Touring' },
        { name: '300C Touring L' },
        { name: '300C Limited' },
        { name: 'Pacifica' },
        { name: 'Voyager' },
        { name: 'Aspen' },
        { name: 'PT Cruiser' },
        { name: 'Town & Country' },
        { name: 'Crossfire' },
        { name: '200' },
        { name: 'LHS' },
        { name: 'Sebring' },
        { name: 'Concorde' }
    ];
    const dodgeModels = [
        { name: 'Select Model', disabled: true },
        { name: 'Avenger' },
        { name: 'Caliber' },
        { name: 'Challenger' },
        { name: 'Charger' },
        { name: 'Charger SRT Hellcat' },
        { name: 'Charger SRT Hellcat Redeye' },
        { name: 'Charger SRT Hellcat Widebody' },
        { name: 'Charger SRT Hellcat Widebody Redeye' },
        { name: 'Dakota'},
        { name: 'Durango' },
        { name: 'Journey' },
        { name: 'Viper' },
        { name: 'Dart' },
        { name: 'Stratus' },
        { name: 'Nitro' },
        { name: 'Grand Caravan' },
        { name: 'SRT-4' }
    ];
    const fiatModels = [ 
        { name: 'Select Model', disabled: true },
        { name: '500' },
        { name: '500L' },
        { name: '500X' },
        { name: '500 Abarth' },
        { name: '500e' },
        { name: '500C' },
        { name: '500C Abarth' },
        { name: '500L Pop' },
        { name: '500L Easy' },
        { name: '500L Lounge' },
        { name: '500L Trekking' },
        { name: '500X Pop' },
        { name: '500X Trekking' },
        { name: '500X Lounge' },
        { name: '500X Sport' },
        { name: '500X Urbana' },
        { name: '124 Spider' },
        { name: '124 Spider Abarth' },
        { name: 'Punto' },
        { name: 'Punto Evo' },
        { name: 'Tipo' },
        { name: 'Uno' },
        { name: 'Panda' },
        { name: 'Panda Cross' },
        { name: 'Bravo' },
        { name: 'Stilo' },
        { name: 'Croma' },
        { name: 'Multipla' },
        { name: 'Ducato' },
        { name: 'Fiorino' },
        { name: 'Qubo' },
        { name: 'Freemont' }
    ];
    
    const ramModels = [
        { name: 'Select Model', disabled: true },
        { name: 'Ram 1500' },
        { name: 'Ram 2500' },
        { name: 'Ram 3500' },
        { name: 'ProMaster' },
        { name: 'ProMaster City' },
        { name: 'ProMaster Cargo' },
        { name: 'ProMaster Cargo Van' },
        { name: 'ProMaster Window Van' },
        { name: 'ProMaster Cutaway' },
        { name: 'ProMaster Chassis Cab' },
        { name: 'ProMaster 1500' },
        { name: 'ProMaster 2500' },
        { name: 'ProMaster 3500' },
        { name: 'ProMaster 4500' },
        { name: 'ProMaster 5500' },
        { name: 'Ram Chassis Cab 3500' },
        { name: 'Ram Chassis Cab 4500' },
        { name: 'Ram Chassis Cab 5500' },
        { name: 'Ram 1500 Classic' },
        { name: 'Ram 1500 TRX' },
        { name: 'Ram 1500 Rebel' }
    ];
    const fordModels = [
        { name: 'Select Model', disabled: true },
        { name: 'Aerostar' },
        { name: 'Bronco' },
        { name: 'Bronco Sport' },
        { name: 'Bronco Sport Badlands' },
        { name: 'Bronco Sport Badlands 4x4' },
        { name: 'C-Max' },
        { name: 'Contour' },
        { name: 'Crown Victoria' },
        { name: 'E-Series' },
        { name: 'Edge' },
        { name: 'EcoSport' },
        { name: 'Escape' },
        { name: 'Escort' },
        { name: 'Expedition' },
        { name: 'Explorer' },
        { name: 'F-150' },
        { name: 'F-150 Lightning' },
        { name: 'F-250' },
        { name: 'F-350' },
        { name: 'F-450' },
        { name: 'F-550' },
        { name: 'Fiesta' },
        { name: 'Five Hundred' },
        { name: 'Flex' },
        { name: 'Focus' },
        { name: 'Freestar' },
        { name: 'Freestyle' },
        { name: 'Fusion' },
        { name: 'Maverick' },
        { name: 'Mustang' },
        { name: 'Mustang Mach-E' },
        { name: 'Probe' },
        { name: 'Ranger' },
        { name: 'Taurus' },
        { name: 'Tempo' },
        { name: 'Thunderbird' },
        { name: 'Transit' },
        { name: 'Transit Connect' },
        { name: 'Windstar' }
    ];
    const genesisModels = [
        { name: 'Select Model', disabled: true },
        { name: 'G70' },
        { name: 'G80' },
        { name: 'G80 Sport' },
        { name: 'G90' },
        { name: 'GV60' },
        { name: 'GV70' },
        { name: 'GV80' },
        // Special trims or versions
        { name: 'G90 3.3T Premium' },
        { name: 'G90 5.0 Ultimate' },
        { name: 'GV80 Prestige' },
        { name: 'GV70 Sport' },
        // Historical Hyundai Genesis (before 2015)
        { name: 'Hyundai Genesis Coupe' },
        { name: 'Hyundai Genesis Sedan' }
    ];
    const gmcModels = [
        { name: 'Select Model', disabled: true },
        // SUVs
        { name: 'Acadia' },
        { name: 'Envoy' },
        { name: 'Envoy XL' },
        { name: 'Envoy XUV' },
        { name: 'Terrain' },
        { name: 'Yukon' },
        { name: 'Yukon XL' },
        { name: 'Yukon Denali' },
        { name: 'Yukon XL Denali' },
    
        // Pickup Trucks
        { name: 'Canyon' },
        { name: 'Canyon Crew Cab' },
        { name: 'Canyon Extended Cab' },
        { name: 'Sierra 1500' },
        { name: 'Sierra 1500 Crew Cab' },
        { name: 'Sierra 1500 Extended Cab' },
        { name: 'Sierra 1500 Denali' },
        { name: 'Sierra 1500 Limited' },
        { name: 'Sierra 1500 Hybrid' },
        { name: 'Sierra 2500HD' },
        { name: 'Sierra 2500HD Crew Cab' },
        { name: 'Sierra 2500HD Denali' },
        { name: 'Sierra 3500HD' },
        { name: 'Sierra 3500HD Crew Cab' },
        { name: 'Sierra 3500HD Denali' },
    
        // Vans
        { name: 'Savana 1500' },
        { name: 'Savana 2500' },
        { name: 'Savana 3500' },
        { name: 'Savana Passenger' },
        { name: 'Savana Cargo' },
        { name: 'Safari' },  // Older model
    
        // Cars (GMC has focused more on trucks/SUVs; limited car offerings historically)
        { name: 'Syclone' },  // Special performance truck (1991)
        { name: 'Typhoon' }  // Performance SUV (1991-1993)
    ];
    const hondaModels = [
        { name: 'Select Model', disabled: true },
        
        // Cars
        { name: 'Accord' },
        { name: 'Accord Hybrid' },
        { name: 'Accord Coupe' },
        { name: 'Accord Crosstour' },
        { name: 'Civic' },
        { name: 'Civic Coupe' },
        { name: 'Civic Hybrid' },
        { name: 'Civic Hatchback' },
        { name: 'Civic Si' },
        { name: 'Civic Type R' },
        { name: 'Insight' },
        { name: 'CR-Z' },  // Hybrid sports compact
        { name: 'Prelude' },  // Discontinued after 2001
        { name: 'S2000' },  // Roadster (2000–2009)
        { name: 'Fit' },
        { name: 'Clarity' },  // Plug-in Hybrid, Electric, and Fuel Cell variants
    
        // SUVs
        { name: 'CR-V' },
        { name: 'Passport' },
        { name: 'Element' },  // Discontinued after 2011
        { name: 'Pilot' },
        { name: 'HR-V' },
    
        // Pickup Trucks
        { name: 'Ridgeline' },
    
        // Vans
        { name: 'Odyssey' },
    
        // Other
        { name: 'Crosstour' }  // A crossover variant of the Accord (2010–2015)
    ];
    const hyundaiModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Accent' },
        { name: 'Elantra' },
        { name: 'Elantra GT' },
        { name: 'Elantra Hybrid' },
        { name: 'Sonata' },
        { name: 'Sonata Hybrid' },
        { name: 'Sonata Plug-in Hybrid' },
        { name: 'Tucson' },
        { name: 'Ioniq' },  // Includes Electric and Hybrid variants
        { name: 'Kona' },
        { name: 'Veloster' },
        { name: 'Genesis' },  // Predecessor to the Genesis luxury brand
        { name: 'Equus' },  // Luxury sedan (2011-2016)
        { name: 'Azera' },  // Discontinued full-size sedan
    
        // SUVs
        { name: 'Santa Fe' },
        { name: 'Santa Fe Sport' },
        { name: 'Santa Fe XL' },
        { name: 'Palisade' },
        { name: 'Venue' },
        
        // Pickup Trucks
        { name: 'Santa Cruz' },  // Newer model introduced in 2021
    
        // Vans
        { name: 'Entourage' },  // Discontinued minivan
        { name: 'Starex' },  // Popular in some markets
    
        // Performance Models
        { name: 'Nexo' }  // Hydrogen fuel cell vehicle
    ];
    const infinitiModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Q45' },       // Historical full-size luxury sedan
        { name: 'Q50' },
        { name: 'Q60' },
        { name: 'Q70' },      // Replaced by Q80 in some markets
    
        // SUVs and Crossovers
        { name: 'QX4' },      // Mid-size SUV (1997-2003)
        { name: 'QX30' },     // Subcompact crossover
        { name: 'QX50' },
        { name: 'QX55' },     // Newer coupe-style SUV
        { name: 'QX60' },
        { name: 'QX70' },     // Formerly FX series
        { name: 'QX80' },
    
        // Notable models (discontinued or concept)
        { name: 'QX56' }    // Predecessor to QX80
        // Placeholder names removed; these do not correspond to actual models
    ];
    const jaguarModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'XJ' },
        { name: 'XF' },
        { name: 'XK' },
        { name: 'F-Type' },
        { name: 'E-Type' },  // Classic sports car (1961-1996, included for historical reference)
    
        // SUVs and Crossovers
        { name: 'F-Pace' },
        { name: 'E-Pace' },
        { name: 'I-Pace' },  // First electric SUV
    
        // Notable models (discontinued or concept)
        { name: 'X-Type' },  // Predecessor to XF
        { name: 'S-Type' },   // Mid-size sedan (1999-2008)
        { name: 'XJ220' }   // Supercar (1992-1994)
    ];
    const jeepModels = [
        { name: 'Select Model', disabled: true },
    
        // SUVs and Trucks
        { name: 'Wrangler' },
        { name: 'Wrangler Unlimited' },  // Longer version of the Wrangler
        { name: 'Cherokee' },
        { name: 'Grand Cherokee' },
        { name: 'Compass' },
        { name: 'Renegade' },
        { name: 'Gladiator' },  // Pickup truck based on Wrangler
        { name: 'Patriot' },    // Discontinued compact SUV
        { name: 'Avenger' },    // Discontinued compact car
    
        // Luxury SUVs
        { name: 'Grand Wagoneer' },  // Luxury SUV
        { name: 'Grand Wagoneer L' }  // Long-wheelbase version
    ];
    const kiaModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Soul' },
        { name: 'Optima' },
        { name: 'Forte' },
        { name: 'Optima Hybrid' },
        { name: 'Niro' },
        { name: 'Niro EV' },
        { name: 'Niro Plug-in Hybrid' },
        { name: 'Rio' },
        { name: 'Rio5' },
        { name: 'Picanto' },  // Smaller city car, available in some markets
        { name: 'Stinger' },
        { name: 'K900' },     // Luxury sedan (2015-2020)
    
        // SUVs
        { name: 'Sorento' },
        { name: 'Sportage' },
        { name: 'Telluride' },
        { name: 'Seltos' },
        { name: 'Carnival' },  // Minivan (formerly Sedona)
    
        // Discontinued Models
        { name: 'Cadenza' }   // Full-size sedan (2017-2020)
    ];
    const landRoverModels = [
        { name: 'Select Model', disabled: true },
    
        // SUVs
        { name: 'Defender' },     // Classic off-roader, reintroduced in 2020
        { name: 'Discovery' },     // Mid-size luxury SUV
        { name: 'Discovery Sport' }, // Smaller SUV based on the Discovery
        { name: 'Range Rover' },   // Full-size luxury SUV
        { name: 'Range Rover Sport' }, // Sporty variant of the Range Rover
        { name: 'Range Rover Velar' }, // Sleek mid-size luxury SUV
        { name: 'Range Rover Evoque' }, // Compact luxury SUV
    
        // Notable Models (discontinued or historical)
        { name: 'LR2' },          // Compact luxury SUV (2007-2015)
        { name: 'LR4' },          // Mid-size SUV (2009-2016)
        { name: 'Range Rover Classic' } // Original Range Rover model
    ];
    const lexusModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'ES' },         // Midsize luxury sedan
        { name: 'GS' },         // Midsize luxury sport sedan (discontinued in 2020)
        { name: 'IS' },         // Compact luxury sedan
        { name: 'LS' },         // Full-size luxury sedan
        { name: 'RC' },         // Compact luxury coupe
        { name: 'LC' },         // Flagship luxury coupe
        { name: 'CT' },         // Compact hybrid hatchback (discontinued in 2017)
        { name: 'LFA' },        // Supercar (2010-2012)
    
        // SUVs and Crossovers
        { name: 'UX' },         // Subcompact luxury crossover
        { name: 'NX' },         // Compact luxury crossover
        { name: 'RX' },         // Midsize luxury SUV
        { name: 'GX' },         // Mid-size luxury SUV with off-road capabilities
        { name: 'LX' },         // Full-size luxury SUV
    
        // Hybrids and Electric Models
        { name: 'ES Hybrid' },
        { name: 'RX Hybrid' },
        { name: 'NX Hybrid' },
        { name: 'LS Hybrid' },
        { name: 'UX Hybrid' },
        { name: 'LC Hybrid' },
        { name: 'RZ' }         // All-electric luxury SUV (introduced in 2022)
    ];
    const lincolnModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Continental' },  // Full-size luxury sedan (discontinued in 2020)
        { name: 'MKZ' },          // Mid-size luxury sedan (discontinued in 2020)
        { name: 'MKS' },          // Full-size luxury sedan (discontinued in 2016)
        { name: 'LS' },           // Mid-size luxury sedan (discontinued in 2006)
    
        // SUVs and Crossovers
        { name: 'Navigator' },    // Full-size luxury SUV
        { name: 'MKC' },          // Compact luxury SUV (discontinued in 2020)
        { name: 'MKT' },          // Full-size luxury crossover (discontinued in 2019)
        { name: 'Corsair' },      // Compact luxury SUV (introduced in 2020)
        { name: 'Aviator' },      // Mid-size luxury SUV (reintroduced in 2020)
    
        // Concept and Special Models
        { name: 'Lincoln MKX' }  // Mid-size luxury crossover (discontinued, rebranded as Nautilus)
    ];
    const mazdaModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Mazda2' },       // Subcompact car (discontinued in some markets)
        { name: 'Mazda3' },       // Compact car
        { name: 'Mazda6' },       // Mid-size sedan (discontinued in some markets)
        { name: 'MX-5 Miata' },   // Iconic roadster
    
        // SUVs and Crossovers
        { name: 'CX-3' },         // Subcompact SUV (discontinued)
        { name: 'CX-30' },        // Subcompact crossover
        { name: 'CX-5' },         // Compact SUV
        { name: 'CX-50' },        // Compact crossover (newer model)
        { name: 'CX-9' },         // Mid-size SUV
        
        // Discontinued Models
        { name: 'Tribute' },      // Compact SUV (discontinued)
        { name: 'Mazda5' },       // Compact MPV (discontinued)
        { name: 'RX-8' },         // Sports car (discontinued)

        // Pickup Trucks
        { name: 'B-Series' }    // Compact pickup truck (discontinued) 
    ];
    const mercedesBenzModels = [
        { name: 'Select Model', disabled: true },
    
        // Sedans
        { name: 'C-Class' },
        { name: 'E-Class' },
        { name: 'S-Class' },
        { name: 'A-Class' },     // Compact luxury sedan
        { name: 'CLA' },         // Compact four-door coupe
        { name: 'CLS' },         // Mid-size luxury coupe
        { name: 'Maybach' },     // Ultra-luxury sedan variant
    
        // SUVs and Crossovers
        { name: 'GLA' },         // Subcompact luxury SUV
        { name: 'GLB' },         // Compact luxury SUV
        { name: 'GLC' },         // Mid-size luxury SUV
        { name: 'GLE' },         // Mid-size luxury SUV
        { name: 'GLS' },         // Full-size luxury SUV
        { name: 'G-Class' },     // Iconic luxury off-roader
    
        // Sports and Performance Models
        { name: 'SL' },          // Luxury roadster
        { name: 'SLC' },         // Compact roadster (discontinued)
        { name: 'AMG GT' },      // High-performance sports car
    
        // Discontinued Models
        { name: 'R-Class' },     // Luxury MPV (discontinued)
        { name: 'B-Class' },     // Compact MPV (discontinued)
        
        // Electric Models
        { name: 'EQS' },         // Full-size luxury electric sedan
        { name: 'EQC' },         // Compact luxury electric SUV
        { name: 'EQS SUV' },     // Full-size luxury electric SUV
        { name: 'EQB' }       // Compact luxury electric SUV
    ];
    const miniModels = [
        { name: 'Select Model', disabled: true },
    
        // Hatchbacks
        { name: 'Mini Hatch' },         // Also known as Mini Cooper
        { name: 'Mini Cooper' },        // Various trims and performance versions
        { name: 'Mini Cooper S' },      // Sportier variant of the Hatch
        { name: 'Mini John Cooper Works' }, // High-performance variant
    
        // Convertibles
        { name: 'Mini Convertible' },   // Convertible version of the Hatch
    
        // SUVs and Crossovers
        { name: 'Mini Countryman' },     // Compact SUV
        { name: 'Mini Paceman' },        // Compact crossover (discontinued)
    
        // Electric Models
        { name: 'Mini Electric (Mini SE)' }, // Electric version of the Mini Hatch
    
        // Discontinued Models
        { name: 'Mini Clubman' },         // Wagon version (still produced but evolved)
        { name: 'Mini Roadster' },        // Two-seater convertible (discontinued)
        { name: 'Mini Coupe' }           // Two-door coupe (discontinued)
    ];
    const mitsubishiModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Lancer' },           // Compact car (discontinued in 2017)
        { name: 'Eclipse' },          // Sports compact (discontinued in 2011)
        { name: 'Galant' },           // Mid-size sedan (discontinued in 2012)
        { name: 'Mirage' },           // Subcompact car
        { name: 'Outlander Sport' },  // Compact SUV (also known as ASX in some markets)
    
        // SUVs and Crossovers
        { name: 'Outlander' },        // Mid-size SUV
        { name: 'Eclipse Cross' },    // Compact crossover
        { name: 'Pajero' },           // Mid-size SUV (known as Montero in some markets, still produced in certain regions)
        { name: 'Montero Sport' },    // SUV variant of the Pajero
    
        // Electric and Hybrid Models
        { name: 'Outlander PHEV' },   // Plug-in hybrid SUV
    
        // Discontinued Models
        { name: 'RVR' },              // Compact SUV (known as ASX in some markets, still produced in some regions)
        { name: 'Diamante' },         // Full-size sedan (discontinued)

        // Pickup Truck Models
        { name: 'D-Max' },           // Pickup truck
        { name: 'Raider'}
    ];
    const nissanModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Altima' },             // Mid-size sedan
        { name: 'Maxima' },             // Full-size sedan
        { name: 'Sentra' },             // Compact sedan
        { name: 'Versa' },              // Subcompact sedan
        { name: '370Z' },               // Sports coupe
        { name: 'GT-R' },               // High-performance sports car
        { name: 'Leaf' },               // Electric hatchback
    
        // SUVs and Crossovers
        { name: 'Rogue' },              // Compact SUV
        { name: 'Murano' },             // Mid-size SUV
        { name: 'Pathfinder' },         // Mid-size SUV
        { name: 'Armada' },             // Full-size SUV
        { name: 'Juke' },               // Subcompact crossover (discontinued)
        { name: 'Kicks' },              // Subcompact SUV
        { name: 'Qashqai' },            // Compact crossover (known as Rogue Sport in some markets)
    
        // Trucks
        { name: 'Titan' },              // Full-size pickup truck
        { name: 'Frontier' },           // Mid-size pickup truck
        { name: 'NV Series' },          // Van series (NV1500, NV2500, NV3500)
    
        // Discontinued Models
        { name: 'Altima Coupe' },       // Sporty variant of the Altima (discontinued)
        { name: 'Rogue Select' },       // Older version of the Rogue (discontinued)
        { name: 'Xterra' },             // Compact SUV (discontinued)
        { name: 'Pathfinder Armada' }  // Larger version of the Pathfinder (discontinued)
    ];
    const paganiModels = [
        { name: 'Select Model', disabled: true },
    
        // Current Models
        { name: 'Zonda' },              // The original model, with various variants and special editions
        { name: 'Huayra' },             // Supercar with multiple variants (Huayra BC, Huayra Roadster, etc.)
        { name: 'Huayra BC' },          // High-performance variant of the Huayra
        { name: 'Huayra Roadster' },    // Convertible version of the Huayra
        { name: 'Huayra Imola' },       // Track-focused variant of the Huayra
    
        // Discontinued Models
        { name: 'Zonda C12' },          // The first production model
        { name: 'Zonda F' },            // Notable variant of the Zonda
        { name: 'Zonda R' },            // Track-focused variant of the Zonda
        { name: 'Zonda Cinque' }       // Limited edition variant of the Zonda
    ];
    const porscheModels = [
        { name: 'Select Model', disabled: true },
    
        // Sports Cars
        { name: '911' },                 // Iconic sports car with numerous variants (Carrera, Turbo, GT3, etc.)
        { name: '718 Boxster' },         // Mid-engine convertible sports car
        { name: '718 Cayman' },          // Mid-engine coupe version of the Boxster
        { name: '918 Spyder' },          // Hybrid supercar (discontinued)
    
        // SUVs and Crossovers
        { name: 'Macan' },               // Compact luxury SUV
        { name: 'Cayenne' },             // Mid-size luxury SUV
        { name: 'Cayenne Coupe' },       // Coupe variant of the Cayenne
    
        // Electric Models
        { name: 'Taycan' },              // Electric sports sedan with multiple variants (Taycan 4S, Turbo, Turbo S)
        { name: 'Taycan Cross Turismo' }, // Electric crossover variant of the Taycan
    
        // Discontinued Models
        { name: 'Porsche 944' },         // Sports car (discontinued in 1991)
        { name: 'Porsche 968' },         // Sports car (discontinued in 1995)
        { name: 'Porsche 928' },         // Luxury sports coupe (discontinued in 1995)
        { name: 'Porsche Carrera GT' }  // Limited production supercar (discontinued)
    ];
    const subaruModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Impreza' },             // Compact car available in sedan and hatchback variants
        { name: 'WRX' },                 // High-performance variant of the Impreza
        { name: 'WRX STI' },             // Performance-focused variant of the WRX
        { name: 'Legacy' },              // Mid-size sedan
        { name: 'BRZ' },                 // Sports coupe, developed in collaboration with Toyota
    
        // SUVs and Crossovers
        { name: 'Forester' },            // Compact SUV
        { name: 'Outback' },             // Crossover/wagon variant of the Legacy
        { name: 'Ascent' },              // Mid-size SUV with three-row seating
        { name: 'Crosstrek' },           // Subcompact crossover (also known as XV in some markets)
    
        // Discontinued Models
        { name: 'Tribeca' },             // Mid-size SUV (discontinued)
        { name: 'Alcyone SVX' },         // Sports coupe (discontinued)
        { name: 'Justy' },               // Subcompact car (discontinued)
        { name: 'Legacy GT' }           // Performance variant of the Legacy (discontinued)
    ];
    const teslaModels = [
        { name: 'Select Model', disabled: true },
    
        // Current Models
        { name: 'Model S' },              // Luxury all-electric sedan
        { name: 'Model 3' },              // Compact all-electric sedan
        { name: 'Model X' },              // Luxury all-electric SUV
        { name: 'Model Y' },              // Compact all-electric SUV
    
        // Upcoming Models
        { name: 'Cybertruck' },           // All-electric pickup truck (anticipated release)
        { name: 'Roadster' },             // High-performance sports car (second generation, anticipated release)
    
        // Special Editions and Variants
        { name: 'Model S Plaid' },        // High-performance variant of the Model S
        { name: 'Model X Plaid' },        // High-performance variant of the Model X
        { name: 'Model 3 Performance' },  // Sporty variant of the Model 3
        { name: 'Model Y Performance' }  // Sporty variant of the Model Y
    ];
    const toyotaModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Camry' },               // Mid-size sedan
        { name: 'Corolla' },             // Compact sedan and hatchback
        { name: 'Avalon' },              // Full-size sedan
        { name: 'Supra' },               // Sports coupe (recently revived)
        { name: 'Prius' },               // Iconic hybrid hatchback
        { name: 'Mirai' },               // Hydrogen fuel cell vehicle
    
        // SUVs and Crossovers
        { name: 'RAV4' },                // Compact SUV
        { name: 'Highlander' },          // Mid-size SUV
        { name: '4Runner' },             // Mid-size SUV with off-road capabilities
        { name: 'Land Cruiser' },        // Full-size luxury SUV
        { name: 'C-HR' },                // Subcompact crossover
        { name: 'Venza' },               // Mid-size crossover (recently revived)
    
        // Trucks
        { name: 'Tacoma' },              // Mid-size pickup truck
        { name: 'Tundra' },              // Full-size pickup truck
    
        // Hybrid and Electric Models
        { name: 'RAV4 Hybrid' },         // Hybrid variant of the RAV4
        { name: 'Camry Hybrid' },        // Hybrid variant of the Camry
        { name: 'Highlander Hybrid' },   // Hybrid variant of the Highlander
        { name: 'Prius Prime' },         // Plug-in hybrid variant of the Prius
    
        // Discontinued Models
        { name: 'Scion xB' },            // Compact car (discontinued)
        { name: 'Scion tC' },            // Sport compact (discontinued)
        { name: 'Celica' },              // Compact sports car (discontinued)
        { name: 'MR2' }                 // Sports car (discontinued)
    ];
    const volkswagenModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'Golf' },                 // Compact car available in various trims (including GTI and R)
        { name: 'Jetta' },                // Compact sedan
        { name: 'Passat' },               // Mid-size sedan
        { name: 'Arteon' },               // Fastback sedan
        { name: 'Beetle' },               // Iconic compact car (discontinued)
        { name: 'Tiguan' },               // Compact SUV
        { name: 'ID.4' },                 // All-electric compact SUV
        { name: 'ID.3' },                 // All-electric hatchback (available in some markets)
    
        // SUVs and Crossovers
        { name: 'Atlas' },                // Mid-size SUV
        { name: 'Atlas Cross Sport' },    // Compact SUV variant of the Atlas
        { name: 'T-Roc' },                // Subcompact SUV (available in some markets)
    
        // Vans
        { name: 'Transporter' },          // Van (various configurations, available in some markets)
        { name: 'Multivan' },             // Multi-purpose vehicle (available in some markets)
    
        // Discontinued Models
        { name: 'Phaeton' },              // Luxury sedan (discontinued)
        { name: 'Scirocco' },             // Sport compact (discontinued)
        { name: 'Touareg' }              // Full-size luxury SUV (replaced by the Atlas in some markets)
    ];
    const volvoModels = [
        { name: 'Select Model', disabled: true },
    
        // Cars
        { name: 'S60' },                  // Compact executive sedan
        { name: 'S90' },                  // Full-size luxury sedan
        { name: 'V60' },                  // Compact wagon
        { name: 'V90' },                  // Full-size luxury wagon
        { name: 'C40 Recharge' },         // Electric compact SUV
        { name: 'XC40' },                 // Subcompact luxury SUV
        { name: 'XC60' },                 // Mid-size luxury SUV
        { name: 'XC90' },                 // Full-size luxury SUV
    
        // Electric and Hybrid Models
        { name: 'XC90 Recharge' },        // Plug-in hybrid variant of the XC90
        { name: 'S60 Recharge' },         // Plug-in hybrid variant of the S60
        { name: 'V60 Recharge' },         // Plug-in hybrid variant of the V60
    
        // Discontinued Models
        { name: 'S70' },                  // Mid-size sedan (discontinued)
        { name: 'V70' },                  // Mid-size wagon (discontinued)
        { name: 'S40' },                  // Compact sedan (discontinued)
        { name: 'C70' },                  // Convertible/coupe (discontinued)
        { name: '850' }                  // Mid-size sedan/wagon (discontinued)
    ];
    
export { acuraModels, 
         AlfaRomeoModels, 
         audiModels, 
         bmwModels,
         buickModels,
         cadillacModels,
         chevroletModels,
         chryslerModels,
         dodgeModels,
         fiatModels,
         fordModels,
         genesisModels,
         gmcModels,
         hondaModels,
         hyundaiModels,
         infinitiModels,
         jaguarModels,
         jeepModels,
         kiaModels,
         landRoverModels,
         lexusModels,
         lincolnModels,
         mazdaModels,
         mercedesBenzModels,
         miniModels,
         mitsubishiModels,
         nissanModels,
         paganiModels,
         porscheModels,
         ramModels,
         subaruModels,
         teslaModels,
         toyotaModels,
         volkswagenModels,
         volvoModels,
         };
